import styled from "styled-components";

import {
  Rows3,
  Columns3,
  Merge,
  Split,
  Trash2,
  MinusSquare,
  Heading,
  Square,
  Table2,
} from "lucide-react";

const Menu = styled.div`
  position: fixed;

  min-width: 240px;

  background: white;

  border-radius: 14px;

  border: 1px solid #e5e7eb;

  padding: 8px;

  z-index: 999999;

  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.12),
    0 4px 10px rgba(0, 0, 0, 0.06);

  animation: popupIn 0.15s ease;

  @keyframes popupIn {
    from {
      opacity: 0;
      transform: scale(0.96);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const Item = styled.button`
  width: 100%;
  height: 40px;

  border: none;

  background: transparent;

  border-radius: 10px;

  display: flex;
  align-items: center;

  gap: 10px;

  padding: 0 12px;

  cursor: pointer;

  font-size: 14px;

  &:hover {
    background: #f3f4f6;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 6px 0;
`;

interface Props {
  editor: any;
  x: number;
  y: number;
  onClose: () => void;
}

export default function TableContextMenu({ editor, x, y, onClose }: Props) {
  const run = (fn: () => void) => {
    fn();
    onClose();
  };

  const toggleBorder = () => {
    const { from } = editor.state.selection;

    const domNode = editor.view.nodeDOM(from);

    if (!domNode) return;

    const table = (domNode as HTMLElement).closest("table");

    if (!table) return;

    table.classList.toggle("no-border");
  };

  return (
    <Menu
      style={{
        left: Math.min(x, window.innerWidth - 260),
        top: Math.min(y, window.innerHeight - 350),
      }}>
      <Item
        onClick={() => run(() => editor.chain().focus().addRowAfter().run())}>
        <Rows3 size={16} />
        Add Row
      </Item>

      <Item
        onClick={() =>
          run(() => editor.chain().focus().addColumnAfter().run())
        }>
        <Columns3 size={16} />
        Add Column
      </Item>

      <Divider />

      <Item
        onClick={() =>
          run(() => editor.chain().focus().toggleHeaderRow().run())
        }>
        <Heading size={16} />
        Header Row
      </Item>

      <Item
        onClick={() =>
          run(() => editor.chain().focus().toggleHeaderColumn().run())
        }>
        <Heading size={16} />
        Header Column
      </Item>

      <Divider />

      <Item
        onClick={() => run(() => editor.chain().focus().mergeCells().run())}>
        <Merge size={16} />
        Merge Cells
      </Item>

      <Item onClick={() => run(() => editor.chain().focus().splitCell().run())}>
        <Split size={16} />
        Split Cell
      </Item>

      <Divider />

      <Item onClick={() => run(() => editor.chain().focus().deleteRow().run())}>
        <MinusSquare size={16} />
        Delete Row
      </Item>

      <Item
        onClick={() => run(() => editor.chain().focus().deleteColumn().run())}>
        <MinusSquare size={16} />
        Delete Column
      </Item>

      <Divider />

      {/* <Item onClick={() => run(toggleBorder)}>
        <Table2 size={16} />
        Toggle Border
      </Item> */}

      <Divider />
      <Divider />

      <Item
        style={{
          color: "#dc2626",
        }}
        onClick={() => run(() => editor.chain().focus().deleteTable().run())}>
        <Trash2 size={16} />
        Delete Table
      </Item>
    </Menu>
  );
}
